import MProfile from './MProfile.vue';

export { MProfile };
export default MProfile;
